export default {"src":"/spot-fe-premarket/_next/static/media/1.19203406.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};